import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';
import { APP_SECTION_LIST } from 'src/constants/queryKeys';
import { PATH_DASHBOARD } from 'src/routes/paths';
import useFormsModalStore from 'src/store/forms';

const AppSectionTableBreadcrumb = () => {
  const { setModal } = useFormsModalStore();

  return (
    <HeaderBreadcrumbs
      heading="فهرست بخش ها"
      links={[
        { name: 'داشبورد', href: PATH_DASHBOARD.general.home },
        { name: 'فهرست بخش ها', href: null },
      ]}
      action={
        <Button
          variant="contained"
          component={RouterLink}
          startIcon={<Iconify icon={'eva:plus-fill'} />}
          onClick={() => setModal({ isOpen: true, data: null, type: APP_SECTION_LIST, title: 'ایجاد بخش ' })}
        >
          بخش جدید
        </Button>
      }
    />
  );
};

export default AppSectionTableBreadcrumb;
